import { makeStyles } from "tss-react/mui";
import colorfull from "dan-api/palette/colorfull";
import { alpha, darken } from "@mui/material/styles";
import { radioClasses } from "@mui/material";
import { lightGreen, red, amber, grey } from "@mui/material/colors";

const useStyles = makeStyles()((theme, _params, classes) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    overflowX: "auto",
    "& table": {
      width: "100%",
      borderCollapse: "collapse",
    },
    "& tr:hover": {
      backgroundColor: "rgba(126, 189, 240, 0.5)",
      cursor: "pointer",
    },
  },
  tableHead: {
    "& tr:nth-of-type(even)": {
      backgroundColor: "#1aa0e187",
    },
    "& tr:nth-of-type(odd)": {
      backgroundColor: "#9ed5f187",
    },
    "& th:nth-of-type(even), & td:nth-of-type(even)": {
      backgroundColor: "#1aa0e200",
    },
    "& tr": {
      padding: "5px 0",
    },
  },
  cover: {
    [`& .${classes.name}, & .${classes.subheading}`]: {
      color: theme.palette.common.white,
    },
    position: "relative",
    width: "100%",
    overflow: "hidden",
    height: "auto",
    backgroundColor:
      theme.palette.mode === "dark"
        ? darken(theme.palette.primary.dark, 0.8)
        : theme.palette.primary.dark,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    backgroundSize: "cover",
    textAlign: "center",
    boxShadow: theme.shadows[7],
    backgroundPosition: "bottom center",
    borderRadius: theme.rounded.medium,
  },
  profileTab: {
    marginTop: -72,
    [theme.breakpoints.down("md")]: {
      marginTop: -48,
    },
    borderRadius: `0 0 ${theme.rounded.medium} ${theme.rounded.medium}`,
    background: alpha(theme.palette.background.paper, 0.8),
    position: "relative",
  },
  profileImg: {
    borderRadius: "50%",
    maxWidth: "100%",
    height: "120px",
    width: "120px",
  },
  dotStatus: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    display: "inline-block",
    borderRadius: "50%",
    marginRight: theme.spacing(0.5),
  },
  online: {
    backgroundColor: lightGreen[500],
  },
  bussy: {
    backgroundColor: red[500],
  },
  idle: {
    backgroundColor: amber[500],
  },
  offline: {
    backgroundColor: grey[500],
  },
  content: {
    // background: alpha(theme.palette.secondary.main, 0.3),
    background: "#0facc9cf",
    height: "100%",
    width: "100%",
    padding: `40px ${theme.spacing(3)} 30px`,
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  name: {},
  subheading: {},
  avatar: {
    margin: `0 auto ${theme.spacing(2)}`,
    width: 120,
    height: 120,
    boxShadow: theme.glow.medium,
  },
  opt: {
    position: "absolute",
    top: 10,
    right: 10,
    "& button": {
      color: theme.palette.common.white,
    },
  },
  verified: {
    margin: theme.spacing(1),
    position: "relative",
  },
  button: {
    marginTop: theme.spacing(1),
  },

  hrLine: {
    background: "#2196f3",
    height: "7px",
    display: "block",
  },
  dividerSection: {
    margin: "auto",
  },
  hrLineSaperator: {
    background: "#2196f3",
    height: "7px",
    display: "block",
    transform: "rotate(90deg) ",
  },

  btnArea: {
    display: "flex",
    float: "right",
    // background: "#000",
    justifyContent: "space-around",
    margin: `${theme.spacing(2)} 0`,
    fontSize: 12,
    [`& .${classes.label}`]: {
      fontSize: 12,
      "& span": {
        fontSize: 12,
      },
    },
    "& button": {
      margin: `0 ${theme.spacing(1)}`,
      background: "#2196f3",
      borderRadius: "12px",
      color: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      "& button": {
        width: "100%",
        margin: 5,
      },
    },
  },
  categoryform: {
    padding: "0 1rem ",
  },
  // profileFormCard: {
  //   boxShadow: "0 0 10px #d2d2d2",
  //   borderRadius: "12px",
  // },
  uploadInput: {
    padding: "0.3rem 6rem 0.3rem 0.5rem",
  },
  previewIMG: {
    borderRadius: "50%",
    padding: "0px 10px",
    marginLeft: "15px",
  },
  fav_sub: {
    display: "flex",
    flexWrap: "wrap",
    span: {
      padding: "5px 15px ",
      margin: "5px 10px",
      fontSize: "18px",
      fontWeight: "600",
      background: "#fff",
      borderRadius: "20px",
    },
  },
  removeBtn: {
    padding: "5px",
    borderRadius: "50%",
    background: "#c1bbbb",
    width: "25px",
    marginLeft: "7px",
  },
  uploadImg: {
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    margin: "-12px 0 0 10px",
  },
  formSelectRequest: {
    padding: "10px",
    borderRadius: "7px",
  },
  radioGropuBtn: {
    flexDirection: "row",
  },
  appRegistrationFormGroup: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  referralButton: {
    background: "#2a9e68",
    fontSize: "20px",
    color: "#fff700",
    maxWidth: "100%",
    width: "calc(100% - 5px)",
    height: "90px",
    borderRadius: "1px",
    [theme.breakpoints.down("xl")]: {
      fontSize: "13px",
    },
    "&:hover": {
      background: "#0a7845",
    },
    span: {
      fontSize: "23px !important",
    },
  },
  appformInputDiv: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    width: "calc( 100% - 14rem )",
    formControl: {
      width: "100%",
    },
  },
  reffOptions: {
    width: "82%",
    float: "right",
    background: "#13469424",
    padding: "20px",
    borderRadius: "5px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },
  roleMappingDiv: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    width: "calc( 100% - 14rem)",
  },
  rolemappingsection: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  technicalQualification: {
    h2: {
      padding: "10px 25px 0 0 ",
    },
  },
  copiedBtn: {
    maxWidth: "100%",
    width: "100px",
    margin: "auto",
  },
  refCode: {
    margin: "auto",
    span: {
      backgroundColor: "#000",
      color: "#fff",
      padding: "10px",
      letterSpacing: "3px",
    },
  },
  progress: {
    backgroundColor: "#d8d8d8",
    borderRadius: "20px",
    position: "relative",
    margin: "1px 0",
    height: "15px",
    // width: "300px",
  },
  progressDone: {
    background: "linear-gradient(to left, #F2709C, #FF9472)",
    boxShadow: "0 3px 3px -5px #F2709C, 0 2px 5px #F2709C",
    borderRadius: "20px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: 0,
    opacity: 0,
    transition: "1s ease 0.3s",
  },
  removeButoon: {
    float: "right",
  },

  // =-================================
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightMedium,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
    display: "flex",
  },
  column: {
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  profileFields: {
    paddingRight: "15px",
  },
  internalUserform: {
    padding: "0 15px",
  },
  addButton: {
    margin: "10px",
    float: "right",
  },
  // profileCardContent: {
  //   height: "100vh",
  // },
  uploadButtonDiv: {
    "& span": {
      border: "1px solid #ffffff9e",
    },
  },
  borderPaperblock: {
    border: "1px solid #0facc9",
    borderRadius: "7px",
  },
  skillremoveBtn: {
    padding: "5px",
    background: "none",
    color: "red",
  },
  listOfSkills: {
    display: "flex",
    flexWrap: "wrap",
  },
  addedSkills: {
    li: {
      margin: "2px",
      padding: "0px 5px",
      background: "#ddd",
    },
  },

  skillTag: {
    padding: "5px 5px",
    borderRadius: "15px",
    margin: "2px",
    backgroundColor: "#2196f3",
    color: "#fff",
  },
  viewResumeBtn: {
    border: "2px solid #bcd9ef",
    padding: "5px 10px",
    borderRadius: "50px",
    background: "#2196f3",
    a: {
      color: "#fff",
    },
  },
  DialogBoxCard: {
    position: "relative",
    // overflowY: "unset !important",
  },
  dialogBoxCancelBtn: {
    position: "absolute",
    top: "15px",
    right: "8px",
    zIndex: "999",
    i: {
      fontSize: "20px",
      cursor: "pointer",
    },
  },

  bg: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
    backgroundImage: `linear-gradient(-45deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 33%, ${theme.palette.secondary.dark} 100%);`,
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      "& span": {
        // color: theme.palette.secondary.light,
        color: "#fff",
        fontWeight: "800",
        fontSize: "22px !important",
      },
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "15px !important",
      color: "#fff",
    },
    borderRadius: theme.rounded.small,
  },

  userModal: {
    ul: {
      li: {
        div: {
          display: "flex",
          alignItems: "center",
          padding: "0 5px",
          p: {
            marginBottom: "0px",
            padding: "10px 7px",
          },
        },
        p: {
          span: {
            fontWeight: "500",
          },
        },
      },
    },
  },
  imageCardModal: { margin: "auto", textAlign: "center" },
  userModalCard: {
    padding: "0px",
  },
  firstCardGrid: {
    padding: "10px",
  },
  secondCarGrid: {
    padding: "20px",
  },
  addresDetailsList: {
    justifyContent: "space-between",
  },
  namedetails: {
    h2: {
      fontWeight: "600",
    },
  },
  divider: {
    // margin: `${theme.spacing(1.5)} 0`,
    margin: `8px 0`,
    background: "none",
  },
  blockDetails: {
    fontWeight: "600",
  },
  certifiedModule: {
    display: "flex",
    flexWrap: "wrap",
  },
  uploadButton: {
    display: "block",
    width: "100%",
    fontSize: "0.875rem", // text-sm
    color: theme.palette.text.secondary, // text-slate-500
    "& .MuiButton-root": {
      marginRight: theme.spacing(1), // file:mr-4
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`, // file:py-1 file:px-2
      borderRadius: theme.shape.borderRadius, // file:rounded-full
      border: "none", // file:border-0
      fontSize: "0.75rem", // file:text-xs
      backgroundColor: theme.palette.grey[700], // file:bg-gray-700
      color: theme.palette.primary.light, // file:text-sky-300
      "&:hover": {
        backgroundColor: theme.palette.grey[600], // hover:file:bg-gray-600
      },
    },
  },
  bioCardButton: {
    flexDirection: "row",
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      gap: "15px",
    },
  },
  imageLightBoxWrapper: {
    img: {
      borderRadius: "50%",
    },
  },
  imageLightBoxWrapper: {
    zIndex: "999",
  },
  statusConfirmed: {
    color: "green",
    fontWeight: "bold",
  },
  statusAttended: {
    color: "blue",
    fontWeight: "bold",
  },
  statusUnattended: {
    color: "red",
    fontWeight: "bold",
  },
  statusParticipated: {
    color: "orange",
    fontWeight: "bold",
  },
  statusCertified: {
    color: "purple",
    fontWeight: "bold",
  },
  statusTransferred: {
    color: "brown",
    fontWeight: "bold",
  },
  statusEnrolled: {
    color: "indigo",
    fontWeight: "bold",
  },
  statusMapped: {
    color: "salmon",
    fontWeight: "bold",
  },
  statusProCertified: {
    color: "violet",
    fontWeight: "bold",
  },

  dialogBoxContentCustomecss: {
    height: "800px",
    overflowY: "initial !important",
  },
  tealAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[5],
  },
  dummyNameAvatar: {
    maxWidth: "100%",
    width: "50px",
    height: "50px",
    margin: "0px",
  },
  emailSubject: {
    maxWidth: "100%",
    width: "calc(100% - 0px)",
  },
  // =========================== Create Activity =========================
  createActivityForms: {
    boxShadow: "0 0 10px #000",
    padding: "20px !important",
    borderRadius: "12px !important",
    background: "rgb(255 255 255 / 95%) ",
    [theme.breakpoints.up("lg")]: {
      margin: "auto",
      maxWidth: "100%",
      // width: "60vw",
    },
  },
  formControlTargetYear: {
    maxWidth: "100%",
    width: "calc( 100% - 5px )",
  },
  targetComponentDiv: {
    [theme.breakpoints.up("lg")]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
  targetComponentFieldDiv: {
    [theme.breakpoints.up("lg")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  // =-================================

  dropZone: {
    position: "relative",
    width: "100%",
    padding: "20px",
    border: "2px dashed #ccc",
    borderRadius: "4px",
    textAlign: "center",
    cursor: "pointer",
  },
  dropZonePrompt: {
    marginBottom: "10px",
  },
  dropZoneFileInput: {
    position: "absolute",
    top: "0",
    left: "0",
    opacity: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },

  dropZoneFiles: {
    marginTop: "10px",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },
  dropZoneFile: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    marginBottom: "8px",
    backgroundColor: "#f9f9f9",
    width: "fit-content",
    "&:hover": {
      backgroundColor: "#f0f0f0",
      cursor: "pointer",
    },
  },
  dropZoneFileName: {
    fontSize: "14px",
    color: "#333",
  },
  dropZoneFileRemove: {
    fontSize: "14px",
    color: "#ff4d4d",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#ff1a1a",
    },
  },

  disabledFieldCustom: {
    "& div[role='combobox']": {
      cursor: "not-allowed",
      color: "rgba(255, 255, 255, 0.25)",
      "&:hover": {
        cursor: "not-allowed",
      },
    },

    "& div[class='dropZone']": {
      cursor: "not-allowed",
      color: "rgba(255, 255, 255, 0.25)",
      "&:hover": {
        cursor: "not-allowed",
      },
    },
  },

  disabledFieldCustom2: {
    cursor: "not-allowed",
    color: "rgba(255, 255, 255, 0.25)",
    "&:hover": {
      cursor: "not-allowed",
    },
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  formDetailsGrid: {
    display: "flex",
    alignItems: "center",
  },
  containerPaper: {
    padding: "20px",
    backgroundColor: "#f4f6f8",
    minHeight: "100vh",
  },

  eventDetailsRadioButtons: {
    [theme.breakpoints.up("lg")]: {
      display: "flex",
      alignItems: "center",
    },
  },
  selectedPreview: {
    display: "flex",
    alignItems: "flex-start",
  },
  bannerImage: {
    maxWidth: "100%",
    width: "300px",
    marginTop: "20px",
    border: " 1px solid #ddd",
  },
  handleColorSection: {
    display: "flex",
  },
  updateEventLabel: {
    fontSize: "10px",
    fontWeight: "600",
  },
  selectedColor: {
    maxWidth: "100%",
    width: "100px",
  },
  bg: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
    backgroundImage: `linear-gradient(-45deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 33%, ${theme.palette.secondary.dark} 100%);`,
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      "& span": {
        // color: theme.palette.secondary.light,
        color: "#fff",
        fontWeight: "800",
        fontSize: "22px !important",
      },
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "15px !important",
      color: "#fff",
    },
    borderRadius: theme.rounded.small,
  },
  DialogBoxPositions: {
    position: "relative",
    top: "-80%",
  },
  eventNameModified: {
    display: "flex",
    flexDirection: "column",
    flexBasis: "center",
    alignItems: "center",
  },
  dialogBoxListStatusItem: {
    display: "flex",
    maxWidth: "100%",

    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
  },
  userStatusLabel: {
    padding: "10px 15px",
    // color: "#fff",
    borderRadius: "10px",
  },
  // hrLine:{
  //   "#:after" : "
  // }

  swalContainer: {
    zIndex: 9999999, // Set the z-index to ensure it's above other elements
  },
  selectField: {
    width: "-webkit-fill-available;", // Fix overflow issue
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  dropdownContainer: {
    maxHeight: "200px", // Set a fixed height to make it scrollable
    overflowY: "auto",
  },
  searchInput: {
    width: "100%",
    marginBottom: "10px",
    padding: "8px",
    boxSizing: "border-box",
  },
  //=============Referrance Card-css================
  bigResume: {
    marginBottom: theme.spacing(5),
    justifyContent: "space-between",
    display: "flex",
    //margin: "15px",
    alignItems: "center",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      //height: 160,
      display: "flex",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      [theme.breakpoints.down("sm")]: {
        paddingRight: 0,
        paddingBottom: theme.spacing(2),
        width: "50%",
        float: "left",
      },
    },
    [`& .${classes.avatar}`]: {
      [theme.breakpoints.up("sm")]: {
        width: 50,
        height: 50,
        "& svg": {
          fontSize: 32,
        },
      },
    },
  },
  sm: {},
  mc: {},
  avatar: {
    marginRight: theme.spacing(1),
    boxShadow: theme.glow.light,
    "& svg": {
      fontSize: 24,
    },
    [`&.${classes.sm}`]: {
      width: 30,
      height: 30,
    },
    [`&.${classes.mc}`]: {
      width: 24,
      height: 24,
      top: 0,
      left: 8,
      marginRight: 0,
    },
  },
  tealAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[3],
  },
  tealText: {
    color: colorfull[3],
    "& svg": {
      fill: colorfull[3],
    },
  },
  purpleText: {
    color: colorfull[1],
    "& svg": {
      fill: colorfull[1],
    },
  },
  purpleAvatar: {
    margin: 10,
    color: "#fff",
    backgroundColor: colorfull[1],
  },
  regCard: {
    width: 250, // Fixed width
    // height: 250, // Fixed height to make it square
    height: 100,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: theme.spacing(2),

    boxShadow: theme.shadows[4], // Increased shadow depth
    // borderRadius: "15px", // Rounded corners for a bubbly look
    borderColor: "#5578f3",
    borderRadius: "90px", // Rounded corners for a bubbly look
    padding: theme.spacing(2),
    transition: "all 0.3s ease",
    // background:
    //   "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,0,255,0.5439425770308124) 0%, rgba(0,212,255,1) 100%)",

    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: theme.shadows[6], // Increased shadow depth on hover
    },
  },

  redCardBorder: {
    border: `2px solid ${theme.palette.error.main}`,
    // borderColor: theme.palette.error.main, // Set border color to error color
    "&:hover": {
      borderColor: theme.palette.error.dark, // Set border color to darker error color on hover
    },

    // put background
    backgroundColor: theme.palette.error.light, // Set background color to error light color
  },

  greenCardBorder: {
    border: `2px solid ${theme.palette.success.main}`,
    // Set border color to success color
    "&:hover": {
      borderColor: theme.palette.success.dark, // Set border color to darker success color on hover
    },
    // put background
    backgroundColor: theme.palette.success.light, // Set background color to success light color
  },

  featureNavPageOrganiserTitle: {
    fontWeight: "bold", // Make the title bold
    fontSize: "1.5rem", // Increase font size
    // color: theme.palette.getContrastText(theme.palette.background.paper), // Ensure good contrast
    color: "white", // Ensure good contrast
    marginTop: theme.spacing(1),
  },
  featureNavPageOrganiserdescription: {
    marginTop: theme.spacing(1),
    fontSize: "1rem",
    color: theme.palette.text.secondary,
  },
  multipleUserStatus: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    backgroundColor: "#fff",
    borderRadius: "10px 10px 0 0 ",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  formInputValue: {
    lineHeight: "1.4375em",
    color: "rgba(0, 0, 0, 0.87)",
    boxSizing: "border-box",
    position: "relative",
    cursor: "text",
    display: "inline-flex",
    alignItems: "center",
    overflow: "hidden",
    border: "1px solid rgba(0, 0, 0, 0.32)",
    borderRadius: "8px",
    padding: "7px",
    width: "calc( 100% - 10px )",
  },
  instituteName: {
    fontSize: "1.5rem !important",
    color: "#fff",
  },
  tableHeadName: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  requestFormHeader: {
    boxShadow: "none",
    border: "1px solid #2196f3",
  },
  downloadButton: {
    borderRadius: "10px",
    color: "#2196f3",
  },
  refferalCard: {
    border: "1px solid #0facc9",
    borderRadius: "5px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      height: "190px",
    },
  },
  referredCardBox: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("xl")]: {
      display: "block",
    },
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
